import { paths } from "@/app/paths"
import { slugify } from "@/utils/slugify"

export type RealEstateOfficeHrefInput = {
  displayName: string
  uniqueListingIdHash: string
  officeCity?: string | null
  officeStateOrProvince?: string | null
  listingCity?: string | null
  listingStateOrProvince?: string | null
}

/**
 * Builds `/real-estate-offices/{locationSlug}/{slugify(name)}-{UniqueListingIdHash}`.
 * Same location segment rules as {@link realEstateAgentHref}.
 *
 * @see paths.realEstateOffice
 * @see src/app/real-estate-offices/[locationSlug]/[id]/page.tsx
 */
export function realEstateOfficeHref(
  input: RealEstateOfficeHrefInput
): string | null {
  const hash = input.uniqueListingIdHash?.trim()
  const displayName = input.displayName?.trim()
  if (!hash || !displayName) return null

  const city =
    input.officeCity?.trim() || input.listingCity?.trim() || ""
  const state =
    input.officeStateOrProvince?.trim() ||
    input.listingStateOrProvince?.trim() ||
    ""

  const locationSlug =
    city && state ? `${slugify(city)}-${slugify(state)}` : "unknown"
  const officeSlug = `${slugify(displayName)}-${hash}`
  return paths.realEstateOffice(locationSlug, officeSlug)
}
